<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 v-if="id != 'new'" class="mb-0 font-medium text-uppercase">
            <router-link to="/apps/users" class="text-center navbar-brand">
              <strong>
                <i class="fas fa-chevron-left"></i> Back
              </strong>
            </router-link>
            <span v-if="id == 'new'">Add New User</span>
            <span v-if="id != 'new'">Edit User</span>
            <span v-if="hasSalesContract" class="badge badge-success ml-2">Enterprise</span>
            <span class="ml-2 pointer" @click.stop="goToPresenterSide(user)">
              <i class="fas fa-eye"></i>
            </span>
          </h5>
        </div>
        <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
          <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
            <ol class="p-0 mb-0 breadcrumb justify-content-end">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/apps/users">Users</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">{{ id }}</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div v-if="user.id" class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->
      <div class="card">
        <div class="card-body">
          <form @submit.prevent="submit">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Status</label>

              <div class="col-sm-10">
                <div class="d-flex align-items-center">
                  <input v-model="user.active" type="checkbox"/>
                  <span class="ml-2 badge badge-primary text-uppercase">
                    <span>{{ user.plan }}</span>
                    <span
                        v-if="checkOneTime()"
                        class="sub-remove pointer"
                        @click="removeSubscription()"
                    >
                      <i
                          class="fas"
                          :class="{'fa-trash-alt': !removeLoading, 'fa-spinner fa-spin': removeLoading }"
                      />
                    </span>
                  </span>
                  <a
                      v-if="!checkOneTime()"
                      class="ml-2 sub-addmore text-primary pointer"
                      @click="showCreateSubscriptionModal"
                  >Add more</a>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Set NoIndex Audience</label>
              <div class="col-sm-10">
                <div class="d-flex align-items-center">
                  <input v-model="user.isNoIndex" type="checkbox" style="margin-top: 8px;"/>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Disable Public Template</label>
              <div class="col-sm-10">
                <div class="d-flex align-items-center">
                  <input v-model="user.isDisablePublicTemplate" type="checkbox"
                         style="margin-top: 8px;"/>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Unpublic All Template</label>
              <div class="col-sm-10">
                <div>
                  <button class="btn btn-danger" type="button" :disabled="loadingUnpublish"
                          @click="unpublishAllPresentation()">Unpublish All Presentations <i
                      v-if="loadingUnpublish" class="fas fa-spin fa-spinner"></i></button>
                </div>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Email</label>

              <div class="col-sm-10">
                <input v-model="user.email" type="email" class="form-control" required/>
              </div>
            </div>
            <div class="hr-line-dashed"></div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">White label audience domain</label>

              <div class="col-sm-10">
                <input v-model="user.whiteLabelLink" type="text" class="form-control"/>
              </div>
            </div>
            <div class="hr-line-dashed"></div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">White label presenter domain</label>

              <div class="col-sm-10">
                <input v-model="user.whiteLabelPresenterDomain" type="text" class="form-control"/>
              </div>
            </div>
            <div class="hr-line-dashed"></div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">White label title</label>
              <div class="col-sm-10">
                <input v-model="user.whiteLabelTitle" type="text" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">White label favicon</label>
              <div class="col-sm-10">
                <img v-if="user.whiteLabelFavicon" :src="user.whiteLabelFavicon" alt="" width="48"
                     height="48">
                <input type="file" class="form-control" accept="image/*" @change="onchangeFavicon"/>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">White label Open graph image</label>
              <div class="col-sm-10">
                <img v-if="user.whiteLabelOgImage" :src="user.whiteLabelOgImage" alt="" width="48"
                     height="48">
                <input type="file" class="form-control" accept="image/*" @change="onchangeOgImage"/>
              </div>
            </div>
            <div class="hr-line-dashed"></div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label" required>First Name</label>

              <div class="col-sm-10">
                <input v-model="user.firstName" type="text" class="form-control"/>
              </div>
            </div>
            <div class="hr-line-dashed"></div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Last Name</label>

              <div class="col-sm-10">
                <input v-model="user.lastName" type="text" class="form-control"/>
              </div>
            </div>
            <div class="hr-line-dashed"></div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Password</label>

              <div class="col-sm-10">
                <input v-model="user.password" type="password" autocomplete="new-password"
                       class="form-control"/>
              </div>
            </div>
            <div class="hr-line-dashed"></div>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Role</label>

              <div class="col-sm-10">
                <b-form-select v-model="user.role" :options="roles" required></b-form-select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Stripe Source</label>

              <div class="col-sm-10">
                <b-form-select v-model="user.stripeSource" :options="stripeSources"
                               required></b-form-select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Country</label>

              <div class="col-sm-10">
                <input v-model="user.country" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Currency</label>

              <div class="col-sm-10">
                <input readonly class="form-control" :value="getCurrency(user.currency)">
              </div>
            </div>
            <div class="hr-line-dashed"></div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Stripe Customer ID</label>
              <div class="col-sm-10">
                <!-- <span class="badge badge-primary">{{user.stripeCustomerId}}</span> -->
                <input v-model="user.stripeCustomerId" type="text" class="form-control">
                <a
                    class="btn btn-danger"
                    style="margin-left: 10px"
                    @click="removeStripeId(user)"
                >
                  <i class="fas fa-trash-alt"></i>
                </a>
              </div>
            </div>
            <div class="hr-line-dashed"></div>
            <div v-if="id != 'new'" class="form-group row">
              <label class="col-sm-2 col-form-label">Indentity Provider</label>

              <div class="col-sm-10">
                <div class="text-p">{{ user.identifyProvider || 'N/A' }}</div>
              </div>
            </div>
            <div v-if="id != 'new'" class="form-group row">
              <label class="col-sm-2 col-form-label">Provider User Email</label>

              <div class="col-sm-10">
                <div class="text-p">{{ user.providerUserEmail || 'N/A' }}</div>
              </div>
            </div>
            <div v-if="id != 'new'" class="form-group row">
              <label class="col-sm-2 col-form-label">Provider User Id</label>

              <div class="col-sm-10">
                <div class="text-p">{{ user.providerUserID || 'N/A' }}</div>
                <a
                    class="btn btn-danger"
                    style="margin-left: 10px"
                    @click="removeProviderId(user)"
                >
                  <i class="fas fa-trash-alt"></i>
                </a>
              </div>
            </div>
            <div v-if="id != 'new'" class="form-group row">
              <label class="col-sm-2 col-form-label">Source</label>

              <div class="col-sm-10">
                <div class="text-p">{{ user.source || 'N/A' }}</div>
              </div>
            </div>
            <div v-if="id != 'new' && user.referrer" class="form-group row">
              <label class="col-sm-2 col-form-label">Referrer</label>

              <div class="col-sm-10">
                <div class="text-p">{{ user.referrer }}</div>
              </div>
            </div>
            <div v-if="id != 'new'" class="form-group row">
              <label class="col-sm-2 col-form-label">Signup Ip Address</label>

              <div class="col-sm-10">
                <div class="text-p">{{ user.signUpIpAddress || 'N/A' }}</div>
              </div>
            </div>

            <div v-if="id != 'new'" class="form-group row">
              <label class="col-sm-2 col-form-label">Created At</label>

              <div class="col-sm-10">
                <div class="text-p">{{ user.createdAt | dateTime }}</div>
              </div>
            </div>

            <div v-if="id != 'new'" class="form-group row">
              <label class="col-sm-2 col-form-label">User type</label>

              <div class="col-sm-10">
                <select v-model="user.type" class="form-control">
                  <option value=""></option>
                  <option value="official">official</option>
                </select>
              </div>
            </div>


            <div class="hr-line-dashed"></div>

            <div v-if="id != 'new'" class="form-group row">
              <label class="col-sm-2 col-form-label">Updated At</label>

              <div class="col-sm-10">
                <div class="text-p">{{ user.updatedAt | dateTime }}</div>
              </div>
            </div>
            <div class="hr-line-dashed"></div>

            <div v-if="user.accountId" class="form-group row">
              <label class="col-sm-2 col-form-label">Team role</label>

              <div class="col-sm-10">
                <b-form-select v-model="user.accountRole" :options="accountRoles"
                               required></b-form-select>
              </div>
            </div>

            <div v-if="user.accountId" class="form-group row">
              <label class="col-sm-2 col-form-label">Team name</label>

              <div class="col-sm-10">
                <a :href="accountUrl">Link</a>
                <input
                    v-model="accountName"
                    type="text"
                    class="form-control"
                    :disabled="user.accountRole !== 'admin'"
                />
              </div>
            </div>

            <div class="text-center form-group">
              <button class="btn btn-primary btn-sm" type="button" @click="backView">Cancel</button>
              <button
                  class="btn btn-primary btn-sm"
                  type="submit"
                  style="margin-left: 10px"
              >Save changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="user.accountId" class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
          <h5 class="text-uppercase">Team</h5>

          <div class="card">
            <div class="card-body table-content">
              <table class="table">
                <thead>
                <tr>
                  <th class="th-date">Name</th>
                  <th class="th-date">Email</th>
                  <th class="th-description">Last activity</th>
                  <th class="th-amount">Usage</th>
                  <th class="th-amount">Role</th>
                  <th class="th-payment-method">Joined</th>
                  <th class="text-center th-action">Action</th>
                </tr>
                </thead>
                <tbody v-if="!isLoadingAccount && accountUsers.length">
                <tr
                    v-for="(item, index) in accountUsers"
                    :key="index"
                    style="width:100%;"
                    class="table-data-body"
                >
                  <td class="receipt-date">
                    {{ item.firstName }} {{ item.lastName }}
                  </td>
                  <td>
                      <span
                          class="pointer text-primary break-any"
                          @click="goToDetail(item.id)"
                      >
                        {{ item.email }}
                      </span>
                    <span v-if="item.id === user.id">
                        &nbsp;(This user)
                      </span>
                  </td>
                  <td>
                      <span>
                        {{ item.lastActivity }}
                      </span>
                  </td>
                  <td>
                      <span>
                        {{ item.presentationCount }} presentation(s), {{ item.onlineCount }} total live participant(s)
                      </span>
                  </td>
                  <td>
                      <span
                          class="text-uppercase"
                          :class="{
                          'text-success': item.accountRole === 'admin',
                          'text-muted': item.accountRole !== 'admin',
                        }"
                      >
                        {{ item.accountRole }}
                      </span>
                  </td>
                  <td>
                      <span>
                        {{ item.joinedAt }}
                      </span>
                  </td>
                  <td class="text-center">
                      <span
                          class="pointer text-danger"
                          @click="removeUser(item.id)"
                      >
                        <i class="fas fa-trash-alt"/>
                      </span>
                  </td>
                </tr>
                <tr v-if="accountUsers.length == 1" class="one-receipt--row">
                  <td class="border-0"/>
                </tr>
                </tbody>
              </table>

              <div
                  v-if="isLoadingAccount"
                  class="d-flex justify-content-center"
              >
                Loading...
              </div>

              <div
                  v-if="!isLoadingAccount && !accountUsers.length"
              >
                <h5
                    class="font-medium text-center"
                    style="line-height: 35px;"
                >
                  <span>
                    User doesn't belong to any team yet.
                  </span>
                </h5>
              </div>
            </div>
          </div>

          <div
              class="text-center form-group"
          >
            <button
                class="btn btn-primary btn-sm"
                style="margin-left: 10px"
                @click="showAddMember()"
            >Add new member
            </button>
          </div>
        </div>

      </div>
    </div>

    <div v-if="user.id" class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
          <h5 class="text-uppercase">Receipts</h5>

          <div class="card">
            <div class="card-body table-content">
              <table class="table">
                <thead>
                <tr>
                  <th class="th-date">Date</th>
                  <th class="th-description">Description</th>
                  <th class="th-amount">Amount</th>
                  <th class="th-payment-method">Payment method</th>
                  <th class="th-status">Status</th>
                  <th class="text-center th-action">Action</th>
                </tr>
                </thead>
                <tbody v-if="!isLoadingReceipts && receipts.length">
                <tr
                    v-for="(item, index) in receipts"
                    :key="index"
                    style="width:100%;"
                    class="table-data-body"
                >
                  <td class="receipt-date">
                      <span
                          class="flex text-primary pointer"
                          @click="showEditReceipt(item.invoiceId)"
                      >
                        {{ item.paymentDate }}
                      </span>
                  </td>
                  <td>
                      <span>
                        {{ item.description }}
                      </span>
                  </td>
                  <td>
                      <span>
                        {{ item.amount }} <span class="text-uppercase">{{ item.currency }}</span>
                      </span>
                  </td>
                  <td>
                      <span>
                        {{ formatPaymentMethod(item) }}
                      </span>
                  </td>
                  <td>
                      <span
                          class="text-uppercase"
                          :class="{
                          'text-success': item.status === 'paid',
                          'text-muted': item.status !== 'paid',
                        }"
                      >
                        {{ item.status }}
                      </span>
                  </td>
                  <td class="text-center">
                      <span
                          class="pointer text-danger"
                          @click="deleteReceipt(item.invoiceId)"
                      >
                        <i class="fas fa-trash-alt"/>
                      </span>
                  </td>
                </tr>
                <tr v-if="receipts.length == 1" class="one-receipt--row">
                  <td class="border-0"/>
                </tr>
                </tbody>
              </table>

              <div
                  v-if="isLoadingReceipts"
                  class="d-flex justify-content-center"
              >
                Loading...
              </div>

              <div
                  v-if="!isLoadingReceipts && !receipts.length"
              >
                <h5
                    class="font-medium text-center"
                    style="line-height: 35px;"
                >
                  <span>
                    User doesn't have any receipt yet.
                  </span>
                </h5>
              </div>
            </div>
          </div>

          <div class="text-center form-group">
            <button
                class="btn btn-primary btn-sm"
                style="margin-left: 10px"
                @click="showCreateReceipt()"
            >Create new receipt
            </button>
          </div>
        </div>

      </div>
    </div>


    <div v-if="user.id" class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
          <h5 class="text-uppercase">Recent History</h5>

          <div class="card">
            <div class="card-body table-content">
              <table class="table">
                <thead>
                <tr>
                  <th class="th-date">ID</th>
                  <th class="th-date">Date</th>
                  <th class="th-action">Action</th>
                  <th class="th-description">User comment</th>
                  <th class="th-meta">Description</th>
                  <th class="th-meta">Ref</th>
                </tr>
                </thead>
                <tbody v-if="!isLoadingHistory && history.length">
                <tr
                    v-for="(item, index) in history"
                    :key="index"
                    style="width:100%;"
                    class="table-data-body"
                >
                  <td class="receipt-date">
                      <span>
                        {{ item.id }}
                      </span>
                  </td>
                  <td class="receipt-date">
                      <span>
                        {{ item.createdAt | dateTime }}
                      </span>
                  </td>
                  <td>
                      <span>
                        {{ item.action }}
                      </span>
                  </td>
                  <td>
                      <span>
                        {{ item.description }}
                      </span>
                  </td>
                  <td>
                      <span class="description">
                        {{ formatPlan(item.meta, item.action) }}
                      </span>
                  </td>
                  <td>
                      <span>
                        {{ item.ref }}
                      </span>
                  </td>
                </tr>
                <tr v-if="receipts.length == 1" class="one-receipt--row">
                  <td class="border-0"/>
                </tr>
                </tbody>
              </table>

              <div
                  v-if="isLoadingHistory"
                  class="d-flex justify-content-center"
              >
                Loading...
              </div>

              <div
                  v-if="!isLoadingHistory && !history.length"
              >
                <h5
                    class="font-medium text-center"
                    style="line-height: 35px;"
                >
                  <span>
                    User doesn't have any history yet.
                  </span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PresentationTable v-if="user.id" :user-id="user.id" :user="user"/>

    <div v-if="user.id" class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card border-danger">
            <div v-if="accountRemoved" class="card-body text-center">
              <span class="badge badge-danger">
                Account removed {{ user.deletedAt | dateTime }}
              </span>
            </div>
            <div v-else class="card-body text-center">
              <span v-if="removalRequested" class="badge badge-secondary mb-2">
                Removal request {{ removalRequestStatus }}
              </span>
              <div>
                <button
                    type="button"
                    class="btn btn-outline-danger"
                    :disabled="removalRequested || isRequestingRemoval"
                    @click="requestAccountRemoval"
                >
                  <i v-if="isRequestingRemoval" class="fa fa-spinner fa-spin mr-1"></i>
                  Request account removal
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
        id="confirm-removal-modal"
        ref="confirm-removal-modal"
        hide-footer
        centered
        title="Confirm account removal"
    >
      <p>
        Request account removal for user #{{ user.id }} ({{ removalTargetEmail }})? This cannot be undone.
      </p>
      <div class="d-block form-group">
        <label for="removal-confirm-email">Type the user's email to confirm</label>
        <input
            id="removal-confirm-email"
            v-model="removalConfirmEmail"
            type="email"
            class="form-control"
            autocomplete="off"
            :placeholder="removalTargetEmail"
            @keyup.enter="removalConfirmEmailMatches && confirmAccountRemoval()"
        >
      </div>
      <div class="text-center">
        <button
            type="button"
            class="mr-2 btn btn-danger"
            :disabled="!removalConfirmEmailMatches"
            @click.prevent="confirmAccountRemoval"
        >
          Request removal
        </button>
        <button type="button" class="btn btn-light" @click="$refs['confirm-removal-modal'].hide()">Cancel</button>
      </div>
    </b-modal>

    <b-modal
        id="create-subscription-modal"
        ref="create-subscription-modal"
        hide-footer
        title="Create a new subscription"
    >
      <div class="d-block form-group">
        <label for="exampleInputEmail1">Choose subscription</label>
        <select v-model="planType" class="form-control" required>
          <optgroup label="One-time">
            <option value="one-time-mini">Mini</option>
            <option value="one-time-small">Small</option>
            <option value="one-time-medium">Medium</option>
            <option value="one-time-large">Large</option>
          </optgroup>
        </select>
      </div>
      <div class="text-center">
        <button type="button" class="mr-2 btn btn-primary" @click.prevent="createSubscription">
          Create subscription
          <i v-if="isCreatingSubscription" class="fa fa-spinner fa-spin"></i>
        </button>
        <button type="button" class="btn btn-light" @click="hideCreateSubscriptionModal">Cancel</button>
      </div>
    </b-modal>

    <b-modal
        id="add-member-modal"
        ref="add-new-member-modal"
        hide-footer
        title="Add member to team"
        size="xl"
    >
      <div class="d-block form-group">
        <label for="exampleInputEmail1">Pick user to add</label>
        <vue-bootstrap-typeahead
            v-model="memberSearch"
            :data="memberList"
            :serializer="s => s.note || `${s.email} (${
            s.accountId && s.accountId === user.accountId
            ? 'Already in team'
            : s.accountId
            ? 'Another team, role: ' + s.accountRole
            : 'Not in any team'
          })`"
            placeholder="Type to search.."
            @hit="selectedMember = $event"
        />
        <div v-if="!selectedMember && memberSearch && !memberList.length" class="mt-2 text-danger">User not
          found
        </div>
      </div>
      <div
          class="text-center"
      >
        <button
            type="button"
            class="mr-2 btn btn-primary" :disabled="!selectedMember && !memberSearch"
            @click.prevent="addMember"
        >
          Add member
          <i v-if="isAddingMember" class="fa fa-spinner fa-spin"></i>
        </button>
        <button type="button" class="btn btn-light" @click="hideAddMember">Cancel</button>
      </div>
    </b-modal>

    <b-modal
        id="create-receipt-modal"
        ref="create-receipt-modal"
        hide-footer
        :title="receipt.invoiceId ? 'Edit receipt' : 'Create new receipt'"
        size="xl"
    >
      <form class="needs-validation" name="createReceipt" @submit.prevent="upsertReceipt">
        <div class="d-block form-group">
          <div class="form-row">
            <div class="col-md-3">
              <label for="amount">Status</label>
              <select v-model="receipt.status" class="form-control" required>
                <option value="paid">Paid</option>
                <option value="refunded">Refunded</option>
                <option value="open">Open</option>
                <option value="draft">Draft</option>
                <option value="void">Void</option>
                <option value="uncollectible">Uncollectible</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="amount">Receipt no</label>
              <input v-model="receipt.invoiceNumber" type="text" class="form-control" disabled>
            </div>
            <div class="col-md-5">
              <label for="amount">Description</label>
              <input v-model="receipt.description" type="text" class="form-control" disabled>
            </div>
          </div>
        </div>

        <div class="d-block form-group">
          <div class="form-row">
            <div class="col-md-2">
              <label for="amount">Source</label>
              <select v-model="receipt.source" class="form-control" required>
                <option value="stripe">Stripe</option>
                <option value="paypal">Paypal</option>
                <option value="bank_transfer">Bank transfer</option>
              </select>
            </div>
            <div class="col-md-2">
              <label for="amount">Payment method</label>
              <select v-model="receipt.paymentMethod.brand" class="form-control">
                <option value="">---</option>
                <option value="visa">Visa</option>
                <option value="mastercard">Mastercard</option>
                <option value="amex">Amex</option>
                <option value="diners">Diners</option>
                <option value="discover">Discover</option>
                <option value="jcb">JCB</option>
                <option value="unionpay">Unionpay</option>
                <option value="other">Other</option>
                <option value="unknown">Unknown</option>
              </select>
            </div>
            <div class="col-md-2">
              <label for="amount">Last four</label>
              <input v-model="receipt.paymentMethod.lastFour" type="text" class="form-control">
            </div>
            <div class="col-md-5">
              <label for="amount">Payment date</label>
              <input v-model="receipt.paymentDate" type="date" class="form-control"
                     placeholder="Date format: 2020-02-20" required>
            </div>
          </div>
        </div>

        <div class="d-block form-group">
          <div class="form-row">
            <div class="col-md-3">
              <label for="amount">Amount</label>
              <input v-model="receipt.amount" min="0" type="text" class="form-control" required>
            </div>
            <div class="col-md-3">
              <label for="amount">Amount Paid</label>
              <input v-model="receipt.amountPaid" disabled min="0" type="text" class="form-control"
                     required>
            </div>
            <div class="col-md-3">
              <label for="amount">Amount Refunded</label>
              <input v-model="receipt.amountRefunded" min="0" type="text" class="form-control" required>
            </div>
            <div class="col-md-2">
              <label for="currency">Currency</label>
              <select v-model="receipt.currency" class="form-control" required>
                <option value="usd">USD</option>
                <option value="sgd">SGD</option>
                <option value="aud">AUD</option>
                <option value="vnd">VND</option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-row">
            <div class="col-md-1">
              <label for="isPaid">Paid</label>
              <div>
                <input v-model="receipt.isPaid" type="checkbox" name="isPaid">
              </div>
            </div>
            <div class="col-md-1">
              <label for="isEnterprise">Enterprise</label>
              <div>
                <input v-model="receipt.isEnterprise" type="checkbox" name="isEnterprise">
              </div>
            </div>
            <div class="col-md-3">
              <label for="billingReason">Billing reason</label>
              <select v-model="receipt.billingReason" class="form-control" name="billingReason" required>
                <option value="manual">Manual</option>
                <option value="upcoming">Upcoming</option>
                <option value="subscription_cycle">Subscription cycle</option>
                <option value="subscription_update">Subscription update</option>
                <option value="subscription_create">Subscription create</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="coupon.id">Coupon ID</label>
              <div>
                <input v-model="receipt.coupon.id" class="form-control" type="text" name="coupon.id">
              </div>
            </div>
            <div class="col-md-3">
              <label for="userIp">User IP</label>
              <div>
                <input v-model="receipt.userIp" class="form-control" type="text" name="userIp">
              </div>
            </div>
          </div>
        </div>

        <div class="d-block form-group">
          <label for="items">Items</label>
          <span
              class="px-2 pointer text-primary"
              @click="addReceiptItem()"
          >
          <i class="fas fa-plus"/>
        </span>

          <div v-for="(item, index) in receipt.lines" :key="index" class="form-group">
            <div class="form-row form-group">
              <div class="col-md-5 input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">Description</div>
                </div>
                <input v-model="item.description" type="text" class="form-control" required>
              </div>
              <div class="col-md-3 input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">Amount</div>
                </div>
                <input v-model="item.amount" min="0" type="text" class="form-control" required>
              </div>
              <div class="col-md-3 input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">Discount</div>
                </div>
                <input v-model="item.discountAmount" min="0" type="0" class="form-control" required>
              </div>
              <div class="col-md-1 input-group" style="justify-content: flex-start; align-items: center;">
              <span
                  class="pointer text-danger"
                  @click="removeReceiptItem(index)"
              >
                <i class="fas fa-trash-alt"/>
              </span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-row">
            <div class="col-md-6">
              <label for="description">Note</label>
              <textarea id="invoice-note" v-model="receipt.note" class="w-100" name="note" cols="30"
                        rows="5"/>
            </div>
            <div class="col-md-5">
              <label for="comment">Enterprise Comment</label>
              <textarea id="invoice-comment" v-model="receipt.comment" class="w-100" name="comment"
                        cols="30" rows="5"/>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button type="submit" class="mr-2 btn btn-primary">
            {{ receipt.invoiceId ? 'Update' : 'Create' }}
            <i v-if="isCreatingReceipt" class="fa fa-spinner fa-spin"></i>
          </button>
          <button type="button" class="btn btn-light" @click="hideCreateReceiptModal">Cancel</button>
        </div>
      </form>
    </b-modal>
    <b-modal
        id="error-modal"
        ref="error-modal"
        hide-footer
        title="Error"
    >
      <div class="text-center">
        <p v-html="errorModalMessage"></p>
      </div>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import _ from 'lodash'
import Config from '@/config'
import backdoor from '@/services/backdoor'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import Utils from '@/utils'
import AccountsAPI from '@/api/accounts'
import AccountRemovalAPI, { OUTSTANDING_REMOVAL_STATUSES } from '@/api/account-removal'

// components
import PresentationTable from '../../components/users/PresentationTable.vue'

export default {
  name: "UserDetail",
  components: {
    VueBootstrapTypeahead,
    PresentationTable,
  },
  data() {
    return {
      id: "",
      user: {},
      roles: [],
      stripeSources: Config.stripeSources,
      submiting: false,
      env: null,
      planType: "",
      isCreatingSubscription: false,
      removeLoading: false,
      isCreatingReceipt: false,
      isLoadingReceipts: false,
      isDeletingReceipt: false,
      receipts: [],
      receipt: {
        coupon: {},
        paymentMethod: {},
        lines: [
          {description: "", amount: 0},
        ]
      },
      isLoadingHistory: false,
      history: [],
      accountRoles: [],
      isLoadingAccount: false,
      accountName: '',
      accountUsers: [],
      accountUrl: '',
      isDeletingAccount: false,
      memberSearch: '',
      memberList: [],
      selectedMember: null,
      isAddingMember: false,
      loadingUnpublish: false,
      errorModalMessage: '',
      hasSalesContract: false,
      removalRequested: false,
      removalRequestStatus: '',
      latestRemovalRequestStatus: '',
      isRemovalStatusLoaded: false,
      isRequestingRemoval: false,
      removalConfirmEmail: ''
    }
  },
  created() {
    this.init()
  },
  computed: {
    // deletedAt covers every removal path (this page, a CSV batch, self-serve), but removeUserAccount stamps it
    // before the sweep runs, so an in-flight or failed removal must keep the badge and the retry button.
    accountRemoved() {
      return !!this.user.deletedAt
        && this.isRemovalStatusLoaded
        && !this.removalRequested
        && this.latestRemovalRequestStatus !== 'failed'
    },
    removalTargetEmail() {
      return this.user.email || this.user.providerUserEmail || ''
    },
    // Email addresses are case-insensitive in practice, so a case slip must not block a valid confirm.
    removalConfirmEmailMatches() {
      const expected = this.removalTargetEmail.trim().toLowerCase()
      return expected !== '' && this.removalConfirmEmail.trim().toLowerCase() === expected
    }
  },
  watch: {
    memberSearch: _.debounce(function (text) {
      this.getUserList(text)
    }, 500),
    '$route': function () {
      this.init()
    },
  },
  mounted() {
    this.env = Config.baseEnv
  },
  methods: {
    init() {
      this.id = this.$route.params.id
      // The '$route' watcher re-runs init() on the same component instance when
      // only params.id changes, so per-user state has to be cleared here or the
      // previous user's pending badge and disabled button carry over to the next.
      this.removalRequested = false
      this.removalRequestStatus = ''
      this.latestRemovalRequestStatus = ''
      this.isRemovalStatusLoaded = false
      this.isRequestingRemoval = false
      this.removalConfirmEmail = ''
      this.roles = JSON.parse(JSON.stringify(Config.roles))
      this.roles.splice(0, 1)

      this.$http.get(Config.api.getAccountRoles).then(
          res => {
            this.accountRoles = res.body.map(role => role.name)
            this.accountRoles.push(null)
          },
          () => {
          }
      )

      if (this.id != "new") {
        this.$http.get(Config.api.getUser + this.id).then(
            res => {
              res.body.role = res.body.role || "audience"
              this.user = res.body
              this.checkSalesContract()
            },
            () => {
              this.$router.push({name: "Users"})
            }
        )
        this.loadData()
      }
    },
    loadData() {
      this.loadReceiptList(this.id)
      this.loadHistory(this.id)
      this.loadAccount(this.id)
      this.loadRemovalRequestStatus(this.id)
    },
    goToDetail(id) {
      this.$router.push({params: {id}})
    },
    onchangeImg(event, cb) {
      let file = event.target.files[0]
      if (!file) return
      let formData = new FormData()
      formData.append("file", file)
      let headers = new Headers()
      headers.append("Content-Type", "application/x-www-form-urlencoded")
      //Upload presentation logo
      let url = Config.api.uploadFavicon
      this.$http.post(url, formData).then(
          res => cb(res),
          () => {
          }
      )
    },
    onchangeFavicon(event) {
      this.onchangeImg(event, (res) => {
        this.user.whiteLabelFavicon = res.body.key
      })
    },
    // FIXME: Should we move this to another endpoint?
    onchangeOgImage(event) {
      this.onchangeImg(event, (res) => {
        this.user.whiteLabelOgImage = res.body.key
      })
    },
    checkOneTime() {
      if (!this.user.id) return
      if (this.user.plan.indexOf("one-time") != -1) return true
      return false
    },
    removeStripeId(user) {
      this.user.stripeCustomerId = null
      this.$http.patch(Config.api.updateUser + user.id, {
        deleteStripe: true
      })
    },
    removeProviderId() {
      const url = Config.api.updateUser + this.id
      this.$http.patch(url, {
        providerUserId: null,
        providerUserEmail: null,
      }).then(
          () => {
            window.location.reload()
          },
          err => {
            this.submiting = false
            this.$toasted.error(err.bodyText)
          }
      )
    },
    submit() {
      this.count++
      if (this.submiting) return
      this.submiting = true
      let payload = {
        role: this.user.role,
        email: this.user.email,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        active: this.user.active,
        stripeSource: this.user.stripeSource,
        accountRole: this.user.accountRole,
        type: this.user.type,
        isDisablePublicTemplate: this.user.isDisablePublicTemplate,
        isNoIndex: this.user.isNoIndex,
        country: this.user.country
      }

      if (this.id == "new" && !this.user.password) {
        this.$toasted.error("Please enter your password")
        return
      }

      let url

      if (this.id == "new") {
        payload.password = this.user.password
        url = Config.api.createStaff
        this.$http.post(url, payload).then(
            () => {
              this.submiting = false
              this.$router.push({name: "Users"})
              this.$toasted.success("Created new account.")
            },
            err => {
              this.submiting = false
              this.$toasted.error(err.bodyText)
            }
        )
      } else {
        if (this.user.password) {
          payload.newPassword = this.user.password
        }
        if (this.user.stripeCustomerId) {
          payload.stripeCustomerId = this.user.stripeCustomerId
        }

        if (this.user.whiteLabelLink) {
          payload.whiteLabelLink = this.user.whiteLabelLink
        } else {
          payload.whiteLabelLink = null
        }

        if (this.user.whiteLabelPresenterDomain) {
          payload.whiteLabelPresenterDomain = this.user.whiteLabelPresenterDomain
        } else {
          payload.whiteLabelPresenterDomain = null
        }

        if (this.user.whiteLabelTitle) {
          payload.whiteLabelTitle = this.user.whiteLabelTitle
        }

        if (this.user.whiteLabelOgImage) {
          payload.whiteLabelOgImage = this.user.whiteLabelOgImage
        }

        if (this.user.whiteLabelFavicon) {
          payload.whiteLabelFavicon = this.user.whiteLabelFavicon
        }

        url = Config.api.updateUser + this.id
        this.$http.patch(url, payload).then(
            () => {
              this.updateAccount(() => {
                this.submiting = false
                this.$toasted.success("User updated!")
                this.init()
              })
            },
            err => {
              this.submiting = false
              this.errorModalMessage = err.bodyText
              this.$refs["error-modal"].show()
            }
        )
      }
    },

    updateAccount(cb) {
      if (this.user.accountId && this.user.accountRole === 'admin') {
        this.$http.put(Config.api.account, {userId: this.user.id, name: this.accountName})
            .then(
                () => cb(),
                () => cb(),
            )
      } else {
        cb()
      }
    },

    backView() {
      this.$router.push({name: "Users"})
    },
    showCreateSubscriptionModal() {
      this.$refs["create-subscription-modal"].show()
      this.planType = ""
    },

    hideCreateSubscriptionModal() {
      this.$refs["create-subscription-modal"].hide()
    },

    createSubscription() {
      if (this.isCreatingSubscription || !this.user.id) return
      this.isCreatingSubscription = true
      let payload = {
        plan: this.planType,
        userId: this.user.id
      }

      this.$http.post(Config.api.createOneTime, payload).then(
          async () => {
            this.isCreatingSubscription = false
            this.user.plan = this.planType
            this.hideCreateSubscriptionModal()
            await backdoor.openPresenterAs(this.user.id)

            // this.user = data ...
          },
          () => {
            this.isCreatingSubscription = false
            alert("something went wrong, pls contact admin.")
          }
      )
    },

    removeSubscription() {
      let cf = confirm(
          "Are you sure that you want to delete this subscription?"
      )
      if (!cf || this.removeLoading || !this.user.id) return
      this.removeLoading = true
      this.$http
          .post(Config.api.stopOneTime, {
            userId: this.user.id
          })
          .then(
              async () => {
                this.removeLoading = false
                this.user.plan = "free"
                await backdoor.openPresenterAs(this.user.id)

                // this.user = data ...
              },
              () => {
                this.removeLoading = false
                alert("something went wrong, pls contact admin.")
              }
          )
      //API Remove subscription
    },

    showEditReceipt(id) {
      this.receipt = {...this.receipts.filter(item => item.invoiceId === id)[0]}
      if (!this.receipt.paymentMethod) {
        this.receipt.paymentMethod = {}
      }
      if (!this.receipt.coupon) {
        this.receipt.coupon = {}
      }
      this.showCreateReceiptModal()
    },

    showCreateReceipt() {
      this.resetReceipt()
      this.showCreateReceiptModal()
    },

    getCurrency(currency) {
      if (!currency) {
        return 'usd'
      }
      return currency
    },

    showCreateReceiptModal() {
      this.$refs["create-receipt-modal"].show()
    },

    hideCreateReceiptModal() {
      this.$refs["create-receipt-modal"].hide()
    },

    loadReceiptList(userId) {
      this.isLoadingReceipts = true
      this.$http.get(Config.api.invoice, {params: {userId}})
          .then(
              (res) => {
                this.receipts = res.body.invoices.map(
                    i => ({...i, paymentDate: Utils.isoDate(i.paymentDate)})
                )
                this.isLoadingReceipts = false
              },
              (err) => {
                this.isLoadingReceipts = false
                alert("something went wrong, pls contact admin.")
                console.error(err)
              }
          )
    },

    showAddMember() {
      this.selectedMember = null
      this.memberSearch = ''
      this.memberList = []
      this.$refs["add-new-member-modal"].show()
    },

    hideAddMember() {
      this.$refs["add-new-member-modal"].hide()
    },

    addMember() {
      this.isAddingMember = true
      this.$http.post(Config.api.account, {userId: this.selectedMember.id, adminId: this.user.id})
          .then(
              () => {
                this.isAddingMember = false
                this.hideAddMember()
                this.init()
              },
              (err) => {
                this.isAddingMember = false
                alert(err.body && err.body.message)
                console.error(err)
              }
          )
    },

    getUserList() {
      this.$http
          .get(Config.api.getListUsers, {
            params: {
              textSearch: this.memberSearch,
            }
          })
          .then(res => {
            this.memberList = res.body.result.filter((u) => {
              return u.active
            })
          })
    },

    loadAccount(userId) {
      this.isLoadingAccount = true
      this.$http.get(Config.api.account, {params: {userId}})
          .then(
              (res) => {
                const {name, users, accountId} = res.body
                this.accountName = name
                this.accountUsers = users.map(
                    i => ({
                      ...i,
                      lastActivity: Utils.isoDateTime(i.lastActivity || i.createdAt),
                      joinedAt: i.accountData && i.accountData.joinedAt ? Utils.isoDateTime(i.accountData.joinedAt) : null,
                    })
                )
                this.accountUrl = `/apps/teams/${accountId}`
                this.isLoadingAccount = false
              },
              (err) => {
                this.isLoadingAccount = false
                alert("something went wrong, pls contact admin.")
                console.error(err)
              }
          )
    },

    loadHistory(userId) {
      this.isLoadingHistory = true
      this.$http.get(Config.api.userHistory, {params: {userId}})
          .then(
              (res) => {
                this.history = res.body
                this.isLoadingHistory = false
              },
              (err) => {
                this.isLoadingHistory = false
                alert("something went wrong, pls contact admin.")
                console.error(err)
              }
          )
    },

    upsertReceipt() {
      const params = {
        ...this.receipt,
        userId: this.user.id,
        amountPaid: this.receipt.amount,
      }
      this.isCreatingReceipt = true
      if (this.receipt.invoiceId) {
        this.$http.patch(Config.api.invoice + this.receipt.invoiceId, params)
            .then(
                () => {
                  this.isCreatingReceipt = false
                  this.hideCreateReceiptModal()
                  this.resetReceipt()
                  this.loadReceiptList(this.user.id)
                },
                (err) => {
                  this.isCreatingReceipt = false
                  alert("something went wrong, pls contact admin.")
                  console.error(err)
                }
            )
      } else {
        this.$http.post(Config.api.invoice, params)
            .then(
                () => {
                  this.isCreatingReceipt = false
                  this.resetReceipt()
                  this.loadReceiptList(this.user.id)
                  this.hideCreateReceiptModal()
                },
                (err) => {
                  this.isCreatingReceipt = false
                  alert("something went wrong, pls contact admin.")
                  console.error(err)
                }
            )
      }
    },

    resetReceipt() {
      this.receipt = {
        paymentMethod: {},
        coupon: {},
        amount: 0,
        amountRefunded: 0,
        discountAmount: 0,
        lines: [
          {description: "", amount: 0, discountAmount: 0},
        ]
      }
    },

    deleteReceipt(invoiceId) {
      let cf = confirm(
          "Are you sure that you want to delete this invoice?"
      )
      if (!cf || this.isDeletingReceipt || !this.user.id) return
      this.isDeletingReceipt = true

      this.$http.delete(Config.api.invoice + invoiceId)
          .then(
              () => {
                this.isDeletingReceipt = false
                this.loadReceiptList(this.user.id)
              },
              (err) => {
                this.isDeletingReceipt = false
                alert("something went wrong, pls contact admin.")
                console.error(err)
              }
          )

    },

    removeUser(userId) {
      let cf = confirm(
          "Are you sure that you want to remove this user from the team?"
      )
      if (!cf || this.isDeletingAccount || !this.user.id) return
      this.isDeletingAccount = true

      this.$http.delete(Config.api.account + userId)
          .then(
              () => {
                this.isDeletingAccount = false
                this.loadAccount(this.user.id)
              },
              (err) => {
                this.isDeletingAccount = false
                alert("something went wrong, pls contact admin.")
                console.error(err)
              }
          )

    },

    addReceiptItem() {
      this.receipt.lines.push({description: "", amount: ""})
    },

    removeReceiptItem(index) {
      this.receipt.lines = this.receipt.lines.filter((_, i) => i != index)
    },

    formatSource(source) {
      if (source === 'stripe') {
        return ''
      }
      const s = source.replace('_', ' ')
      return `${s[0].toUpperCase()}${s.slice(1)} `
    },

    formatBrand(paymentMethod) {
      return (paymentMethod && paymentMethod.brand && paymentMethod.lastFour)
          ? `${paymentMethod.brand.toUpperCase()} •••• •••• •••• ${paymentMethod.lastFour}`
          : ''
    },

    formatPaymentMethod(receipt) {
      return this.formatSource(receipt.source) + this.formatBrand(receipt.paymentMethod)
    },

    formatPlan(meta, action) {
      if (action === 'Pay failed') {
        return meta
      }

      if (meta && meta.plan) {
        return `${meta.plan.name} (from ${meta.plan.timeStart} to ${meta.plan.timeEnd})`
      } else if (meta && meta.email) {
        return `From: ${meta.email.oldEmail} to: ${meta.email.newEmail}`
      } else if (meta && meta.reason) {
        return `Reason: ${meta.reason}`
      }
    },

    async goToPresenterSide(item) {
      if (item.isLoading) return
      item.isLoading = true
      try {
        await backdoor.openPresenterAs(item.id)
      } finally {
        item.isLoading = false
      }
    },
    async unpublishAllPresentation() {
      if (this.loadingUnpublish) return
      this.loadingUnpublish = true
      const resp = await this.$http.get(Config.api.getTemplateByUser, {
        params: {
          userId: this.user.id
        }
      })
      if (resp.body.length) {
        await this.$http.post(Config.api.unpublishTemplateByUser, {
          presentationIds: resp.body.map(item => item.id),
          userId: this.user.id,
        })
      }

      this.loadingUnpublish = false
      this.$toasted.success("Unpublish done!")
    },

    async checkSalesContract() {
      if (!this.user.accountId) return
      
      try {
        const salesContracts = await AccountsAPI.getSalesAssistedContract({ 
          accountIds: [this.user.accountId] 
        })
        this.hasSalesContract = Utils.hasEnterpriseContract(salesContracts, this.user.accountId)
      } catch (error) {
        console.error('Error fetching sales contract:', error)
      }
    },

    // Answers "is a removal already outstanding for this user?" from the server.
    // Without it the badge and the disabled button only ever reflected a click
    // made in this session, so a request filed yesterday -- or by another admin
    // -- left the button enabled and the badge hidden on every fresh load.
    //
    // One row is enough: the partial unique index keeps at most one outstanding
    // row per user, and a new row can only be inserted once the previous one is
    // terminal, so an outstanding row is always the newest the list returns.
    async loadRemovalRequestStatus(userId) {
      try {
        const { removalRequests } = await AccountRemovalAPI.listRemovalRequests({ userId, limit: 1 })
        const outstanding = removalRequests.find((row) => OUTSTANDING_REMOVAL_STATUSES.includes(row.status))
        this.removalRequested = !!outstanding
        this.removalRequestStatus = outstanding ? outstanding.status : ''
        this.latestRemovalRequestStatus = removalRequests.length ? removalRequests[0].status : ''
        this.isRemovalStatusLoaded = true
      } catch (err) {
        // Leave the button enabled rather than block on a failed read -- the
        // create endpoint reports an already-outstanding request either way.
        console.error(err)
      }
    },

    requestAccountRemoval() {
      this.removalConfirmEmail = ''
      this.$refs['confirm-removal-modal'].show()
    },

    async confirmAccountRemoval() {
      if (!this.removalConfirmEmailMatches) return
      this.$refs['confirm-removal-modal'].hide()

      this.isRequestingRemoval = true
      try {
        const { created, alreadyPending } = await AccountRemovalAPI.createRemovalRequests({ userIds: [this.user.id] })
        // Compare as strings: the ids come straight off an INTEGER column, so a
        // change to how they are serialised would otherwise turn both branches
        // false and report a failure on a request the server accepted.
        const matchesUser = (userId) => String(userId) === String(this.user.id)
        if ((alreadyPending || []).some(matchesUser)) {
          this.removalRequested = true
          this.removalRequestStatus = 'pending'
          this.$toasted.show('A removal request is already pending for this user.', {
            type: 'info',
            duration: 4000,
          })
        } else if ((created || []).some((row) => matchesUser(row.userId))) {
          this.removalRequested = true
          this.removalRequestStatus = 'pending'
          this.$toasted.success('Account removal requested.')
        } else {
          this.$toasted.error('Failed to request account removal')
        }
      } catch (err) {
        console.error(err)
        // A rejected payload (no such account, over the 50-user cap) answers 400
        // with the reason -- the generic toast alone hides why it failed.
        this.$toasted.error((err && err.body && err.body.message) || 'Failed to request account removal')
      } finally {
        this.isRequestingRemoval = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.description {
  display: inline-block;
  max-height: 100px;
  max-width: 350px;
  overflow: auto;
}

.break-any {
  word-wrap: anywhere;
}
</style>
